import { COUNTERTOP_NONE_KEY } from '../../../countertop-material/constants';
import { ActionRuleParams } from '../../types';
import { syncPromotionalSkuCount } from '../../helpers';

const SKU = 'NON-COUNTERTOP-SALE';

export const nonCountertopSale = (params: ActionRuleParams): void => {
	const { refMap } = params;
	const { kitchen } = refMap;
	if (!kitchen) return;

	const { key } = kitchen.material.countertop;
	const isNonCountertop = key === COUNTERTOP_NONE_KEY;

	const qualifyingCount = isNonCountertop ? 1 : 0;

	syncPromotionalSkuCount({ kitchen, sku: SKU, qualifyingCount });
};
